import React from "react";

export default function Stepper({
  steps = [],
  currentStep = 0,
  onStepChange,
  type = "readonly", 
}) {
  const progress = (currentStep / (steps.length - 1)) * 100;

  const handleClick = (index) => {
    if (type === "update" && onStepChange) {
      onStepChange(index);
    }
  };

  return (
    <div className="relative flex items-center justify-between w-full max-w-3xl mx-auto">
      <div className="absolute top-3 left-7 right-6 h-0.5 bg-gray-700 z-0">
        <div
          className="h-0.5 bg-cyellow transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Steps */}
      {steps.map((step, index) => (
        <div
          key={index}
          className={`z-10 flex flex-col items-center ${
            type === "editable" ? "cursor-pointer" : "cursor-default"
          }`}
          onClick={() => handleClick(index)}
        >
          <div
            className={`w-6 h-6 cursor-pointer rounded-full border-2 flex items-center justify-center ${
              index <= currentStep ? "border-cyellow" : "border-cgreen"
            }`}
          >
            <div
              className={`w-2 h-2 rounded-full ${
                index <= currentStep ? "bg-cyellow" : "bg-cgreen"
              }`}
            />
          </div>
          <span
            className={`text-sm mt-2 relative flex items-center justify-center ${
              index <= currentStep ? "text-cyellow" : "text-gray-500"
            }`}
          >
            {step}
          </span>
        </div>
      ))}
    </div>
  );
}
